import React, { useEffect, useMemo, useState } from 'react';
import { getLocale } from 'umi';
import { useStateRef } from '@op/hooks/common';
import CommentsCard from '@op/pages/accounts/widgets/CommentsCard';
import { arrayToObj, sortArrayAuxiliaryFunc } from '@op/utils';
import { channelInfo } from '@op/components/ChannelLabel';
import { channelSortList } from '@op/constants/channel';
import CardLoading from '@op/components/CardLoading';
import SingleChannelSelect from '@op/components/FilterCommon/widgets/ChannelSelect/SingleChannelSelect';
import { addStudioChannel } from '../../StudioTrendingVideo/utils';
import "./index.scss";
import { JumpType } from '@home/utils/utils';
const OpinionsAccountsOverview = (props: any) => {
  const { type = 'channel', filter: propsFilter, filterCond, filterLoading, channelList, wholeGameInfo, gameInfo, extraParams, id, refArray, index, style } = props || {};

  const filter = useMemo(() => {
    if (!propsFilter?.date_type || !filterCond) return {};
    const { entity_image, isConfirm, ...restFilter } = propsFilter || {};
    const { channel } = filterCond || {};
    return { ...(restFilter || {}), channels: channel?.['social'], ...extraParams };
  }, [extraParams, filterCond, propsFilter]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [noDataMapRef, noDataMap, setNoDataMap] = useStateRef<{
    [key: string]: any;
  }>({});
  const [accountOrderBy, setAccountOrderBy] = useState('followers');
  const [defaultNavigators, setDefaultNavigators] = useState([]);
  const [navigators, setNavigators] = useState([]);

  const getChannelInfo = () => {
    const sortList = filter?.channels?.sort(sortArrayAuxiliaryFunc(channelSortList));
    let navigators: any = sortList?.map((item: string) => ({
      symbol: item,
      noFormat: true,
    }));

    const accounts: any = filterCond?.accounts?.map((item: string) =>
      item?.toLocaleLowerCase(),
    );

    let channelMap: any = {};
    const list = channelList || [];
    channelMap = arrayToObj(list, 'channel');
    navigators = navigators.map((item: { symbol: any; }) => {
      const { name, img } = channelInfo(item.symbol);
      // eslint-disable-next-line prefer-const
      let { List, total } = channelMap[item.symbol] || { List: [], total: 0 };
      // 过滤掉用户未选中的
      List = List.filter((item: string) =>
        accounts.includes(item?.toLocaleLowerCase()),
      );
      if (List.length === 0) {
        // 如果没有官号数据，那么就使用undefined占位，以防止请求认为是获取所有官号
        List = ['undefined'];
      }
      return {
        ...item,
        name,
        symbol: item.symbol,
        social_media_by_account: List,
        accounts: List,
        total,
        channels: addStudioChannel([item.symbol]),
        channel: {
          name,
          img,
          channel_name: item.symbol,
        },
      };
    });
    setDefaultNavigators(navigators);
    setNavigators(filterValue?.channel?.length === 0 ? navigators : navigators?.filter((item: { symbol: any; }) => filterValue?.channel?.includes(item?.symbol)));
  };

  useEffect(() => {
    if (!filter.edition_unified_id || !filter?.channels) return;
    if (type === 'channel' && channelList?.length > 0) {
      getChannelInfo();
    }
  }, [filter, accountOrderBy, type, channelList]);

  const [filterValue, setFilterValue] = useState({ channel: [], channel_type: "social" });
  const filterOptions = useMemo(() => {
    // 有数据需要展示的channel
    const showChannel: any[] = [];
    channelList?.forEach((item: { total: number; List: string | any[]; channel: any; }) => {
      if (item?.total > 0 && item?.List?.length > 0) {
        showChannel?.push(item?.channel);
      };
    });
    const filterOptions = {
      ...filterCond?.channel,
      social: filterCond?.channel?.social?.filter((item: any) => showChannel?.includes(item))
    };
    return filterOptions;
  }, [channelList, filterCond?.channel]);

  return (
    <div className='dbh-opinions-accounts-overview'>
      <CardLoading loading={filterLoading}>
        <div className='dbh-opinions-accounts-overview-filter'>
          {channelList?.length > 0 && <SingleChannelSelect
            defaultValue={{
              channel_comments: [],
              channel_news: [],
              channel_securitys: [],
              channel_social: [],
              channel_type_select: []
            }}
            defaultKey={'channel'}
            filterOptions={filterOptions}
            filterValue={filterValue}
            lang={getLocale()}
            channelKey={'social'}
            pointKey={'channel'}
            onChange={() => { }}
            changeOnCloseWindow={(value: any) => {
              setFilterValue(value);
              if (value?.channel?.length === 0) {
                setNavigators(defaultNavigators);
              } else {
                setNavigators(defaultNavigators?.filter((item: { symbol: any; }) => value?.channel?.includes(item?.symbol)));
              }
            }}
          />}
        </div>
        <div className='dbh-opinions-accounts-overview-scroll-placeholder' data-scroll-index={index} ref={refArray?.[index]} id={id} style={style}>
        </div>
        <CommentsCard
          setAccountOrderBy={setAccountOrderBy}
          accountOrderBy={accountOrderBy}
          type={type}
          loading={false}
          navigators={navigators}
          keepParams={filter}
          setNoDataMap={(key: string, value: any) => {
            setNoDataMap({ ...noDataMapRef.current, [key]: value });
          }}
          noDataMap={noDataMapRef.current}
          wholeGameInfo={wholeGameInfo}
          gameInfo={gameInfo}
          jumpType={JumpType.Window}
        ></CommentsCard>
      </CardLoading>
    </div>
  );
};

export default OpinionsAccountsOverview;
